module.exports = __webpack_public_path__ + "img/tu_02.ef5442c2.png";